import axios from "axios";

export const getProfile = async (
  apiToken: string) => {
  
  return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/users/profile`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            }
        });
  }
